"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MultipleCircle: ['multiple-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 Z', 'M15.75,14.25V12a3.75,3.75,0,0,0-7.5,0v2.25h1.5l.75,6h3l.75-6Z', 'M2.250 6.000 A2.250 2.250 0 1 0 6.750 6.000 A2.250 2.250 0 1 0 2.250 6.000 Z', 'M5.7,9.947A3.753,3.753,0,0,0,.75,13.5v.75h1.5L3,18.75H6l.376-2.256', 'M17.250 6.000 A2.250 2.250 0 1 0 21.750 6.000 A2.250 2.250 0 1 0 17.250 6.000 Z', 'M18.3,9.947A3.753,3.753,0,0,1,23.25,13.5v.75h-1.5L21,18.75H18l-.376-2.256', 'M23.25,21c0,1.243-5.037,2.25-11.25,2.25S.75,22.243.75,21']],
  MultipleHome: ['multiple-home', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.500 14.250 A3.000 3.000 0 1 0 10.500 14.250 A3.000 3.000 0 1 0 4.500 14.250 Z', 'M11.25,23.25V22.5a3.75,3.75,0,0,0-7.5,0v.75', 'M13.500 14.250 A3.000 3.000 0 1 0 19.500 14.250 A3.000 3.000 0 1 0 13.500 14.250 Z', 'M20.25,23.25V22.5a3.75,3.75,0,0,0-6.4-2.652', 'M23.25 23.25L23.25 12 12 0.75 0.75 12 0.75 23.25']],
  MultipleManWoman2: ['multiple-man-woman-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z', 'M12.75,18.75h1.5l.75,4.5h4.5l.75-4.5h3L21,12c-.75-2.25-1.679-3.75-3.75-3.75a3.343,3.343,0,0,0-3.156,2.25', 'M14.250 3.750 A3.000 3.000 0 1 0 20.250 3.750 A3.000 3.000 0 1 0 14.250 3.750 Z']],
  MultipleNeutral1: ['multiple-neutral-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z', 'M15.000 3.750 A3.000 3.000 0 1 0 21.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 Z', 'M13.5,15.75H15l.75,7.5h4.5l.75-7.5h2.25V13.5a5.25,5.25,0,0,0-9.75-2.7']],
  MultipleManWoman4: ['multiple-man-woman-4', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.000 3.750 A3.000 3.000 0 1 0 21.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 Z', 'M15,15.75l.75,7.5h4.5l.75-7.5h2.25V13.5a5.25,5.25,0,0,0-9.75-2.7', 'M9,23.25l.75-4.5h3L10.5,12C9.75,9.75,8.821,8.25,6.75,8.25S3.75,9.75,3,12L.75,18.75h3l.75,4.5Z', 'M3.750 3.750 A3.000 3.000 0 1 0 9.750 3.750 A3.000 3.000 0 1 0 3.750 3.750 Z']],
  MultipleManWoman1: ['multiple-man-woman-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z', 'M6 8.25L6 14.25', 'M15.000 3.750 A3.000 3.000 0 1 0 21.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 Z', 'M13.5,15.75H15l.75,7.5h4.5l.75-7.5h2.25V13.5a5.246,5.246,0,0,0-2.364-4.386L18,13.5,15.114,9.114A5.292,5.292,0,0,0,13.5,10.8', 'M15,3.75S15,7.5,12.75,7.5', 'M21,3.75S21,7.5,23.25,7.5']],
  MultipleNeutral2: ['multiple-neutral-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M11.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H3l.75,7.5h4.5L9,15.75h2.25Z', 'M6 8.25L6 14.25', 'M15.000 3.750 A3.000 3.000 0 1 0 21.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 Z', 'M13.5,15.75H15l.75,7.5h4.5l.75-7.5h2.25V13.5a5.251,5.251,0,0,0-9.75-2.706', 'M18 8.25L18 14.25']],
  MultipleWoman2: ['multiple-woman-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M9,23.25l.75-4.5h3L10.5,12C9.75,9.75,8.821,8.25,6.75,8.25S3.75,9.75,3,12L.75,18.75h3l.75,4.5Z', 'M3.750 3.750 A3.000 3.000 0 1 0 9.750 3.750 A3.000 3.000 0 1 0 3.750 3.750 Z', 'M14.250 3.750 A3.000 3.000 0 1 0 20.250 3.750 A3.000 3.000 0 1 0 14.250 3.750 Z', 'M14.625,21,15,23.25h4.5l.75-4.5h3L21,12c-.75-2.25-1.679-3.75-3.75-3.75s-3,1.5-3.75,3.75']],
  MultipleWoman1: ['multiple-woman-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 A3.000 3.000 0 1 0 3.000 3.750 Z', 'M8.25,23.25,9,15.75h2.25V13.5A5.246,5.246,0,0,0,8.886,9.114L6,13.5,3.114,9.114A5.246,5.246,0,0,0,.75,13.5v2.25H3l.75,7.5Z', 'M3,3.75S3,7.5.75,7.5', 'M9,3.75S9,7.5,11.25,7.5', 'M15.000 3.750 A3.000 3.000 0 1 0 21.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 Z', 'M13.5,15.75H15l.75,7.5h4.5l.75-7.5h2.25V13.5a5.246,5.246,0,0,0-2.364-4.386L18,13.5,15.114,9.114A5.292,5.292,0,0,0,13.5,10.8', 'M15,3.75a6.123,6.123,0,0,1-.75,2.908', 'M21,3.75S21,7.5,23.25,7.5']],
  MultipleUsers1: ['multiple-users-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.250 6.000 A2.250 2.250 0 1 0 6.750 6.000 A2.250 2.250 0 1 0 2.250 6.000 Z', 'M4.5,9.75A3.75,3.75,0,0,0,.75,13.5v2.25h1.5l.75,6H6', 'M17.250 6.000 A2.250 2.250 0 1 0 21.750 6.000 A2.250 2.250 0 1 0 17.250 6.000 Z', 'M19.5,9.75a3.75,3.75,0,0,1,3.75,3.75v2.25h-1.5l-.75,6H18', 'M9.000 3.750 A3.000 3.000 0 1 0 15.000 3.750 A3.000 3.000 0 1 0 9.000 3.750 Z', 'M17.25,13.5a5.25,5.25,0,0,0-10.5,0v2.25H9l.75,7.5h4.5l.75-7.5h2.25Z']]
};
exports["default"] = _default;